import { Card } from "../cards/model";
import { CardRow, Layout, PlaceHolderRow, Row, TitleRow } from "./model";

export function getNewTitleRow() {
  return {
    layout: Layout.Row_1,
    type: "title",
    style: "h1",
    titles: [""],
  } as TitleRow;
}

export function getNewCardRow() {
  return {
    layout: Layout.Row_2,
    type: "card",
    cards: [null, null],
  } as CardRow;
}

export function isTitleRow(row: Row): row is TitleRow {
  return row && row.type === "title";
}

export function isCardRow(row: Row): row is CardRow {
  return row && row.type === "card";
}

export function isTextRow(row: Row) {
  return isTitleRow(row) && row.style === "text";
}

export function isPlaceholderRow(row: Row): row is PlaceHolderRow {
  return row && row.type === "placeholder";
}

export function hasDynamicTitles(row: TitleRow) {
  return !!row.dynamicTitles && row.dynamicTitles.length > 0;
}

export function hasDynamicCardTitle(card: Card) {
  return !!card.dynamicTitle && !!card.dynamicTitle.key;
}
